<template>
  <div>
    <el-dialog top="30px" append-to-body :visible.sync="childdialogshow" width="900px" :before-close="cancel"
      :show-close="false">
      <el-row slot="title"><el-col :span="21" style="font-size: 18px; color: black">支付明细</el-col>
        <el-col :span="3" style="color: red; font-size: 25px; cursor: pointer; text-align: right"><i
            class="el-icon-close" @click="cancel"></i>
        </el-col>
      </el-row>
      <div class="app-container">
        <el-table ref="selectmember" class="app-table" :data="list" border fit highlight-current-row stripe
          style="width: 100%; height: 100%" :height="300" :header-cell-style="{ background: '#F3F4F7', color: '#555' }"
          :row-style="{ height: '10px' }" :cell-style="{ padding: '7px 0' }">
          <el-table-column :key="i" v-for="(col, i) in columns" :label="col.label" :align="col.align" :prop="col.value"
            :type="col.type" :width="col.width">
          </el-table-column>
          <el-table-column :min-width="80" label="操作" align="center">
            <template slot-scope="{ row }">
              <el-tooltip content="退款" placement="top">
                <el-button v-if="authunsettle && row.PayAmount > row.DeductionAmount && (row.PayType == 1||row.PayType==2)&&row.PaywayName!='商户余额'" circle
                  icon="el-icon-minus" size="mini" type="warning" @click="returndvanceview(row)">
                </el-button></el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" style="margin-right: 10px">关 闭</el-button>
      </div>
    </el-dialog>
    <!-- 退预付款 -->
    <el-dialog :visible.sync="returnadvancemodel.dialogshow" append-to-body :show-close="false" :width="'457px'">
      <el-row slot="title"><el-col :span="21" style="font-size: 18px; color: black; text-align: left">支付退款</el-col>
        <el-col :span="3" style="
              color: red;
              font-size: 25px;
              cursor: pointer;
              text-align: right;
            "><i class="el-icon-close" @click="returnadvancemodel.dialogshow = false"></i>
        </el-col>
      </el-row>
      <div class="app-container" style="padding: 30px 30px">
        <div class="filter-container2">
          <el-form>
            <el-form-item label="支付方式：" label-width="90px">
              {{ returnadvancemodel.PaywayName }}
            </el-form-item>
            <el-form-item label="支付金额：" label-width="90px">
              {{ returnadvancemodel.PayAmount }},可退金额{{
      returnadvancemodel.PayAmount -
      returnadvancemodel.DeductionAmount
    }}。
            </el-form-item>
            <el-form-item label="支付时间：" label-width="90px">
              {{ returnadvancemodel.PayTime }}
            </el-form-item>
            <el-form-item label="退款金额：" label-width="90px">
              <el-input-number style="width: 200px" @focus="inputfocus($event)" :min="0" :step="0.01"
                :max="returnadvancemodel.maxQuantity" v-model="returnadvancemodel.returnmodel.PayAmount"
                controls-position="right"></el-input-number>
            </el-form-item>
            <el-form-item v-if="!returnadvancemodel.returnmodel.authmark" label="备注：" label-width="90px">
              <el-input style="width: 200px" v-model="returnadvancemodel.returnmodel.authcode"
                placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="returnadvancemodel.dialogshow = false">取 消</el-button>
        <el-button type="primary" :disabled="returnloading" :loading="returnloading" @click="returnadvance()"
          style="margin-right: 10px">{{ returnloading == false ? "确 定" : "退款处理中" }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style lang="less" scoped>
.dialog-footer {
  height: 60px;
  margin-top: 30px;
  padding-top: 5px;
}
/deep/ .el-dialog__body {
  padding: 5px 0px 5px 0px !important;
}
/deep/ .el-dialog__footer {
  padding: 0px 0px !important;
  box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.1);
}
/deep/ .el-dialog__header {
  padding: 10px 10px 0px !important;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
}
</style>
<script>
import { getpaylistbyorderid, retutnamountbyid, refundresultquery } from "@/api/order";
import waves from "@/directive/waves"; // waves directive
export default {
  name: "selectmember",
  components: {},
  directives: { waves },
  props: {
    dialogshow: {
      required: true,
      type: Boolean,
    },
    OrderId: {
      required: true,
      type: String,
    },
    authunsettle: {
      required: true,
      type: Boolean,
    }
  },
  computed: {
    childdialogshow: {
      get() {
        return this.dialogshow;
      },
      set(val) {
        this.$emit("update:dialogshow", val);
      },
    },
    createform: {
      get() {
        return this.editform;
      },
    },
    membergradelist: {
      get() {
        return this.pmembergradelist;
      },
    },
  },
  data() {
    return {
      selectrow: {},
      list: null,
      pageIndex: 1,
      total: 0,
      returnloading: false,
      columns: [
        {
          label: "序号",
          value: "index",
          align: "center",
          type: "index",
          width: 55,
        },
        {
          label: "支付方式",
          value: "PaywayName",
          align: "center",
          type: "",
        },
        {
          label: "支付金额",
          value: "PayAmount",
          align: "center",
          type: "",
        },
        {
          label: "支付时间",
          value: "PayTime",
          align: "center",
          type: "",
          width: 180
        },
        {
          label: "款项",
          value: "PayTypeName",
          align: "center",
          type: "",
        },
        {
          label: "收款人",
          value: "CreateUserName",
          align: "center",
          type: "",
        }
      ],
      returnadvancemodel: {
        dialogshow: false,
        maxQuantity: 0,
        GoodsName: "",
        returnmodel: {
          Id: 0,
          PayAmount: 0,
          SaleId: 0,
        },
      },
      listQuery: {
        pageIndex: 1,
        pageSize: 15,
        orderColumn: "",
        orderbyasc: false,
        querymodel: {
          keyword: "",
        },
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    inputfocus(event) {
      event.currentTarget.select();
    },
    returndvanceview(row) {
      this.returnadvancemodel.returnmodel.Id = row.Id;
      this.returnadvancemodel.returnmodel.PayAmount =
        row.PayAmount - row.DeductionAmount;
      this.returnadvancemodel.DeductionAmount = row.DeductionAmount;
      this.returnadvancemodel.maxQuantity = row.PayAmount - row.DeductionAmount;
      this.returnadvancemodel.PaywayName = row.PaywayName;
      this.returnadvancemodel.PayAmount = row.PayAmount;
      this.returnadvancemodel.PayTime = row.PayTime;
      this.returnadvancemodel.returnmodel.SaleId = this.OrderId;
      this.returnadvancemodel.dialogshow = true;
    },
    returnadvance() {
      this.returnloading = true;
      retutnamountbyid(this.returnadvancemodel.returnmodel).then((res) => {
        if (res.PayState === 1) {
          this.$message({
            type: "success",
            message: "退款成功!",
          });
          this.returnadvancemodel.dialogshow = false;
          this.returnloading = false;
          this.getList();
        }
        if (res.PayState === 2) {
          this.qpayresult(res.PayOrderNo);
        }
        if (res.PayState === 3) {
          this.returnloading = false;
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    qpayresult(payorderno) {
      let i = 1;
      let timer = setInterval(() => {
        refundresultquery({ refund_sn: payorderno }).then((res) => {
          if (i === 40 || res.PayState === 3 || res.PayState === 1) {
            clearInterval(timer);
            if (res.PayState === 1) {
              this.$message({
                type: "success",
                message: "退款成功!",
              });
              this.order.dialogshow = false;
              this.returnadvancemodel.dialogshow = false;
              this.returnloading = false;
              this.getList();
            }
            if (res.PayState === 3 || i === 40) {
              this.$message({
                type: "error",
                message: res.msg,
              });
              this.returnloading = false;
            }
          }
          i++;
        });
      }, 3000);
    },
    typechange() {
      this.getList();
    },
    getList() {
      getpaylistbyorderid({ OrderId: this.OrderId }).then((res) => {
        this.list = res;
      });
    },
    save() {
      if (this.selectrow != null) {
        this.childdialogshow = false;
        this.$emit("selectcomplete", this.selectrow);
      } else {
        this.$message({
          message: "您至少需要选择一行！",
          type: "warning",
        });
      }
    },
    cancel() {
      this.$emit("cancelcomplete");
    },
  },
  mounted() { },
};
</script>
